<template>
    <div class="container marketing">
        <Nav></Nav>
        <div style="width:100%; height:80px;"></div>
        <Row height="720" bg="assets/pc/service/marketing/p1_bg.jpg"> </Row>
        <Row height="850" bgColor="#fff">
            <div class="pos2">
                <img src="@/assets/pc/service/marketing/pos2_banner.png" />
                <h1>突破营销技术边界 构建全链路营销服务矩阵</h1>
                <p>通过互联网、数字传播技术和数字交互式媒体来实现营销目标，提供智能营销、数字广告<br />社群营销、电商运营等服务，致力于为客户量身定制跨平台、多场景的整合数字营销解决方案。</p>
            </div>
        </Row>
        <Footer></Footer>
    </div>
</template>
<script>
import Nav from "@/components/pc/nav.vue";
import Footer from "@/components/pc/footer.vue";
import Row from "@/components/pc/Row.vue";
export default {
    name: "pc-service-marketing",
    components: { Nav, Footer, Row },
    mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
};
</script>
<style scoped>
.pos2 {
    width: 100%;
    height: 100%;
    text-align: center;
}
.pos2 p {
    font-size: 1.8rem;
    line-height: 4.5rem;
}

@media only screen and (max-width: 2048px) {
    .pos2 img {
        margin-top: 100px;
        width: calc(1300px * var(--scale));
    }
    .pos2 h1 {
        font-size: 2.5rem;
        margin: 140px 0 80px 0;
    }
}

@media only screen and (min-width: 2049px) {
    .pos2 img {
        margin-top: 120px;
        width: 1300px;
    }
    .pos2 h1 {
        font-size: 2.5rem;
        margin: 200px 0 80px 0;
    }
}
</style>
